export const SET_LOGIN_INFO = 'SET_LOGIN_INFO'
